import { AuthService, PlanService, UserService } from "@/app/services";
import "@/presentation/assets/font/stylesheet.css";
import "@/presentation/assets/theme/theme.scss";
import BarChart from "@/presentation/components/BarChart.vue";
import Button from "@/presentation/components/Button.vue";
import Container from "@/presentation/components/Container.vue";
import DateFilters from "@/presentation/components/DateFilters.vue";
import DateRange from "@/presentation/components/DateRange.vue";
import FormButton from "@/presentation/components/FormButton.vue";
import Header from "@/presentation/components/Header.vue";
import ImageCropper from "@/presentation/components/ImageCropper/ImageCropper.vue";
import Input from "@/presentation/components/Input/Input.vue";
import InputContainer from "@/presentation/components/Input/InputContainer.vue";
import InputError from "@/presentation/components/Input/InputError.vue";
import InputGroup from "@/presentation/components/Input/InputGroup.vue";
import InputLabel from "@/presentation/components/Input/InputLabel.vue";
import PasswordInput from "@/presentation/components/Input/PasswordInput.vue";
import LoadingContainer from "@/presentation/components/LoadingContainer.vue";
import Logo from "@/presentation/components/Logo.vue";
import ModalComponent from "@/presentation/components/ModalComponent.vue";
import Navbar from "@/presentation/components/Navbar.vue";
import NotificationToast from "@/presentation/components/NotificationToast.vue";
import Select from "@/presentation/components/Select.vue";
import Sidebar from "@/presentation/components/Sidebar.vue";
import Spinner from "@/presentation/components/Spinner.vue";
import Table from "@/presentation/components/Table/Table.vue";
import TableBody from "@/presentation/components/Table/TableBody.vue";
import TableCard from "@/presentation/components/Table/TableCard.vue";
import TableEmptyState from "@/presentation/components/Table/TableEmptyState.vue";
import TableHead from "@/presentation/components/Table/TableHead.vue";
import TablePagination from "@/presentation/components/Table/TablePagination.vue";
import TableSearch from "@/presentation/components/Table/TableSearch.vue";
import Typograph from "@/presentation/components/Typograph.vue";
import router, { routes } from "@/presentation/router";
import "@fortawesome/fontawesome-free/css/all.css";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import "bootstrap";
import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import { HttpService } from "./infra/api";
import ReadOnlyInput from "./presentation/components/Input/ReadOnlyInput.vue";
import { EventBus } from "./utils/EventBus";

const app = createApp(App);
const pinia = createPinia();
const http = HttpService();

app.config.globalProperties.$routes = routes;
app.config.globalProperties.$authService = AuthService(http);
app.config.globalProperties.$eventBus = EventBus;

app.provide("userService", UserService(http));
app.provide("planService", PlanService(http));

app.component("ReadOnlyInput", ReadOnlyInput);
app.component("Input", Input);
app.component("Typograph", Typograph);
app.component("Logo", Logo);
app.component("Button", Button);
app.component("Spinner", Spinner);
app.component("FormButton", FormButton);
app.component("Navbar", Navbar);
app.component("Sidebar", Sidebar);
app.component("NotificationToast", NotificationToast);
app.component("Container", Container);
app.component("Header", Header);
app.component("TableCard", TableCard);
app.component("TableSearch", TableSearch);
app.component("Table", Table);
app.component("TableHead", TableHead);
app.component("TableBody", TableBody);
app.component("TablePagination", TablePagination);
app.component("LoadingContainer", LoadingContainer);
app.component("TableEmptyState", TableEmptyState);
app.component("VueDatePicker", VueDatePicker);
app.component("DateRange", DateRange);
app.component("Select", Select);
app.component("DateFilters", DateFilters);
app.component("InputLabel", InputLabel);
app.component("BarChart", BarChart);
app.component("InputError", InputError);
app.component("InputContainer", InputContainer);
app.component("InputGroup", InputGroup);
app.component("ModalComponent", ModalComponent);
app.component("ImageCropper", ImageCropper);
app.component("PasswordInput", PasswordInput);

app.use(pinia).use(router).mount("#app");
